'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import type { MouseEvent } from 'react';
import AppLink from '@/components/elementary/AppLink';
import { isDefaultLocale, sortLocaleLinksByAppLocales } from '@/components/elementary/LocaleSwitcher/utils';
import { ButtonGroup } from '@/components/ui/button-group';
import { LOCALE_TRANSLATION } from '@/constants/i18n.constants';
import { cn } from '@/lib/styles';
import type { AppLocale } from '@/types/general';
import type { LocaleLink } from '@/types/i18n.types';
type Props = {
  currentLocale: AppLocale;
  localeLinks: LocaleLink[];
  onLocaleChange?: (locale: AppLocale) => void;
};
export function MobileLocaleSwitcher(t0) {
  const $ = _c(20);
  const {
    currentLocale,
    localeLinks,
    onLocaleChange
  } = t0;
  const t = useTranslations("LocaleSwitcher");
  let t1;
  if ($[0] !== onLocaleChange) {
    t1 = locale => event => {
      if (!onLocaleChange) {
        return;
      }
      event.preventDefault();
      onLocaleChange(locale);
    };
    $[0] = onLocaleChange;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleLocaleLinkClick = t1;
  let T0;
  let t2;
  let t3;
  let t4;
  if ($[2] !== currentLocale || $[3] !== handleLocaleLinkClick || $[4] !== localeLinks || $[5] !== t) {
    const sortedLinks = sortLocaleLinksByAppLocales(localeLinks);
    T0 = ButtonGroup;
    if ($[10] !== t) {
      t2 = t("selectLanguage");
      $[10] = t;
      $[11] = t2;
    } else {
      t2 = $[11];
    }
    t3 = "w-full";
    let t5;
    if ($[12] !== currentLocale || $[13] !== handleLocaleLinkClick) {
      t5 = link => {
        const isActive = link.locale === currentLocale;
        const useNativeAnchor = isDefaultLocale(link.locale);
        return isActive ? <span key={link.locale} aria-current="true" className={cn("lok-text-body-bold-large bg-peach-200", "flex-1 inline-flex items-center justify-center rounded-full border border-neutral-500 h-12 text-neutral-900 uppercase")}>{link.locale}</span> : <AppLink key={link.locale} href={link.pathname} locale={link.locale} forceAnchor={useNativeAnchor} variant="none" size="none" aria-label={LOCALE_TRANSLATION[link.locale as keyof typeof LOCALE_TRANSLATION]} className={cn("lok-text-body-regular-large", "flex-1 inline-flex items-center justify-center rounded-full border border-neutral-500 h-12 text-neutral-900 uppercase")} onClick={handleLocaleLinkClick(link.locale)}>{link.locale}</AppLink>;
      };
      $[12] = currentLocale;
      $[13] = handleLocaleLinkClick;
      $[14] = t5;
    } else {
      t5 = $[14];
    }
    t4 = sortedLinks.map(t5);
    $[2] = currentLocale;
    $[3] = handleLocaleLinkClick;
    $[4] = localeLinks;
    $[5] = t;
    $[6] = T0;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    T0 = $[6];
    t2 = $[7];
    t3 = $[8];
    t4 = $[9];
  }
  let t5;
  if ($[15] !== T0 || $[16] !== t2 || $[17] !== t3 || $[18] !== t4) {
    t5 = <T0 aria-label={t2} className={t3}>{t4}</T0>;
    $[15] = T0;
    $[16] = t2;
    $[17] = t3;
    $[18] = t4;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  return t5;
}